import ConfirmationNumberOutlinedIcon from '@material-ui/icons/ConfirmationNumberOutlined';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

export const activityFeedLogTypes = {
    WorkOrderStatusChange: 1,
    TicketStatusChange: 2,
    VendorAssignmentChange: 3,
    HotNoteEdit: 4,
    TicketAssignmentChange: 5,
    TicketDueDateEdit: 6,
    ExceptionEngineTriggerFired: 7,
    Creation: 8,
    TicketCreation: 9,
    AutomationTriggerCreation: 10,
};

export const ticketFeedLogTypes = [
    activityFeedLogTypes.TicketStatusChange,
    activityFeedLogTypes.TicketAssignmentChange,
    activityFeedLogTypes.TicketDueDateEdit,
    activityFeedLogTypes.TicketCreation,
];

export const creationFeedLogTypes = [
    activityFeedLogTypes.Creation,
    activityFeedLogTypes.TicketCreation,
    activityFeedLogTypes.AutomationTriggerCreation,
];

// TODO: update to the actual production launch date before release
export const WO_LEVEL_LOGS_LAUNCH_DATE = '2026-06-07';

export const activityTimelineMessages = {
    empty: 'No activity has been recorded for this Work Order yet.',
    error: 'History failed to load, refresh page to retry.',
    legacy: 'This Work Order was created before ParQ.ai implemented WO-level logs.',
};

export const entryIconByType = {
    [activityFeedLogTypes.WorkOrderStatusChange]: AutorenewIcon,
    [activityFeedLogTypes.TicketStatusChange]: ConfirmationNumberOutlinedIcon,
    [activityFeedLogTypes.VendorAssignmentChange]: PersonOutlineIcon,
    [activityFeedLogTypes.HotNoteEdit]: DescriptionOutlinedIcon,
    [activityFeedLogTypes.TicketAssignmentChange]: ConfirmationNumberOutlinedIcon,
    [activityFeedLogTypes.TicketDueDateEdit]: ConfirmationNumberOutlinedIcon,
    [activityFeedLogTypes.ExceptionEngineTriggerFired]: ReportProblemOutlinedIcon,
    [activityFeedLogTypes.Creation]: AddCircleOutlineIcon,
    [activityFeedLogTypes.TicketCreation]: ConfirmationNumberOutlinedIcon,
};
